import { useEffect } from "react";
import { ZEFFY_5K_URL } from "@/lib/api";

export default function FiveKRedirect() {
    useEffect(() => {
        window.location.replace(ZEFFY_5K_URL);
    }, []);
    return (
        <div className="min-h-screen flex items-center justify-center bg-[#F2E8D5] p-6 text-center" data-testid="5k-redirect">
            <div>
                <div className="text-xs tracking-[0.3em] uppercase text-stone-500">Redirecting</div>
                <h1 className="mt-2 font-serif text-3xl">Taking you to our Step Forward Community Walk…</h1>
                <p className="mt-3 text-stone-600">
                    If you aren&apos;t redirected automatically,{" "}
                    <a href={ZEFFY_5K_URL} className="text-brand-purple underline" data-testid="5k-redirect-link">
                        click here to sign up
                    </a>.
                </p>
            </div>
        </div>
    );
}
